
import { Component, Prop, Vue } from 'vue-property-decorator';
import { regular } from '@/const/regular';
import { lAreaData } from '@/const/LAreaData';
import dialogImgLarge from '@/components/ImgLarge/index.vue';

@Component({
  name: 'BranchAdd',
  components: {
    dialogImgLarge
  },
  filters: {
    fullImgUrl(value: string) {
      // return BranchIndexController.qiniu.default_url + value;
    }
  }
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })dialogBranchOperationVisible!:Boolean;

  @Prop({
    type: String,
    default: '添加分公司'
  })title!:String;

  @Prop({
    type: Object,
    default: () => ({})
  })branchForm!:Object;

  // 省市区元数据
  private lAreaData = lAreaData;
  private selected = ''
  // 保存返回数据
  private selectAreaBean:any={}

  private defaultProps:any = {
    children: 'child',
    label: 'name',
    value: 'id'
  }

  private maxLevel = 4;
  private loading = false;
  private qiniu = { token: '', key: '', default_url: '', action: '' };
  private imgLargePath = '';

  private regular = regular;
  private rules= {
    name: [
      { required: true, message: '请输入5-30位由字母、数字、中文、小括号组成的公司名称', trigger: 'blur' },
      {
        pattern: this.regular.companyName.pattern,
        message: '请输入5-30位由字母、数字、中文、小括号组成的公司名称',
        trigger: 'blur'
      }
    ],
    manager: [
      {
        pattern: regular.userName.pattern,
        message: '请输入2-10位由字母、中文组成的姓名',
        trigger: 'blur'
      }
    ],
    mobile: [
      {
        pattern: regular.mobile.pattern,
        message: '请输入正确格式的手机号码',
        trigger: 'blur'
      }
    ],
    phone_num: [
      {
        pattern: regular.phone.pattern,
        message: '请输入5-12位电话号码',
        trigger: 'blur'
      }
    ],
    address: [
      {
        pattern: regular.address.pattern,
        message: '请输入2-50个字符组成的地址',
        trigger: 'blur' }
    ]
  }

  // created() {
  //   this.lAreaData.map(item => {
  //     if (item.child.length === 0) {
  //       (item.child as any) = undefined;
  //     } else {
  //       item.child.map(temp => {
  //         if (temp.child.length === 0) {
  //           (temp.child as any) = undefined;
  //         }
  //       });
  //     }
  //   });
  // }

  private areaChange() {

  }

  private uploadSuccess() {}

  private beforeUpload() {}

  private branchAddHandle() {

  }

  private close() {
    this.$emit('close', false);
  }

  private deleteImg() {
    (this.branchForm as any).certificate_img = '';
  }

  private largeImg(val: any) {
    let enlargedData = {
      isShow: true,
      imgList: [val],
      initNum: 0
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }
}
